import { CardDescription, CardTitle } from '@/components/ui/card';

export default function ClubSettingsCardHeader({ icon: Icon, title, description, attention = false }) {
    return (
        <div className="flex items-start gap-3">
            <div className="relative flex size-11 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
                <Icon className="size-5" />
                {attention ? (
                    <span
                        className="club-nav-alert-dot absolute -right-0.5 -top-0.5"
                        title="Configuração pendente"
                        aria-label="Configuração pendente"
                    />
                ) : null}
            </div>
            <div className="min-w-0">
                <CardTitle>{title}</CardTitle>
                {description ? <CardDescription className="mt-1">{description}</CardDescription> : null}
            </div>
        </div>
    );
}
